<div mat-dialog-content>
  <p>A new matching period will be created. All participants will be reset to inactive.</p>

  <div class="period-name">
    <ng-container *ngIf="!isEditingName">
      <span>The new matchrun period will be: <b>{{ matchingPeriodName || '...' }}</b></span>
      <button mat-button type="button" color="primary" (click)="startEditingName()" [disabled]="isLoadingName">Edit</button>
    </ng-container>

    <mat-form-field *ngIf="isEditingName" appearance="outline" class="period-name-field">
      <mat-label>Matching period name</mat-label>
      <input matInput [(ngModel)]="matchingPeriodName" (ngModelChange)="onNameChange()" (keyup.enter)="createNew()" autocomplete="off" />
      <mat-hint>Format: YYYY-N or YYYY-N.M, for example 2027-1 or 2026-4.1</mat-hint>
    </mat-form-field>
  </div>

  <p class="period-name-error" *ngIf="nameError">{{ nameError }}</p>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button type="button" color="primary" mat-dialog-close (click)="close()">Cancel</button>

  <ng-container>
    <button mat-raised-button type="submit" color="accent" (click)="createNew()" [disabled]="isCreating || isLoadingName || !matchingPeriodName">
      Create matching period
    </button>
  </ng-container>
</div>
